import React from 'react'
import RcDropdown from 'rc-dropdown'

export interface DropdownProps {
  visible: boolean
  onVisibleChange: (visible: boolean) => void
  className?: string
  children?: React.ReactNode
  trigger?: string | string[]
  overlay: React.ReactElement | (() => React.ReactElement)
}

/** @deprecated Do not use directly - use DropdownMenu instead */
const Dropdown: React.FC<DropdownProps> = ({
  visible,
  trigger,
  overlay,
  children,
  className,
  onVisibleChange
}) => {
  return (
    <RcDropdown
      visible={visible}
      trigger={trigger}
      overlay={overlay}
      className={className}
      onVisibleChange={onVisibleChange}
    >
      {children}
    </RcDropdown>
  )
}

export default Dropdown
